export const detectLastWordEndPosition = (html: string): number => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html

  const getLastNode = (node: Node): Node | null => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
      return node
    }
    for (let i = node.childNodes.length - 1; i >= 0; i--) {
      const child = getLastNode(node.childNodes[i])
      if (child) return child
    }
    return null
  }

  const lastNode = getLastNode(tempDiv)

  if (!lastNode) {
    return -1
  }

  if (lastNode.nodeType === Node.TEXT_NODE) {
    const textContent = lastNode.textContent!
    const words = textContent.trim().split(/\s+/)
    const lastWord = words.pop()
    if (!lastWord) return -1

    const textNodeStart = html.indexOf(textContent)
    return textNodeStart + textContent.lastIndexOf(lastWord) + lastWord.length
  }

  if (lastNode.nodeType === Node.ELEMENT_NODE) {
    const element = lastNode as HTMLElement
    const outerHTML = element.outerHTML
    const elementStart = html.indexOf(outerHTML)
    return elementStart + outerHTML.length - 1
  }

  return -1
}

export const wrapLastWordWithClass = (
  innerHTML: string,
  spanClass: string
): string => {
  const lastWordEndPosition = detectLastWordEndPosition(innerHTML)

  if (lastWordEndPosition === -1) {
    return innerHTML
  }

  const leftWhitespaceIndex = innerHTML
    .slice(0, lastWordEndPosition)
    .lastIndexOf(' ')

  const lastWordStartPosition =
    leftWhitespaceIndex === -1 ? 0 : leftWhitespaceIndex + 1

  const rightWhitespaceIndex =
    innerHTML.slice(lastWordEndPosition).search(/\s|$/) + lastWordEndPosition

  const beforeLastWord = innerHTML.slice(0, lastWordStartPosition)
  const lastWord = innerHTML.slice(lastWordStartPosition, rightWhitespaceIndex)
  const afterLastWord = innerHTML.slice(rightWhitespaceIndex)

  const wrappedLastWord = `<span class="${spanClass}">${lastWord}</span>`

  return `${beforeLastWord}${wrappedLastWord}${afterLastWord}`
}
